import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api';
import PageHeader from '../components/PageHeader';
import { Ic, fmtNum } from '../components/ui';

const BASE_URL = window.location.origin;

const BADGE = { green: 'badge-success', red: 'badge-danger', blue: 'badge-info', teal: 'badge-accent', yellow: 'badge-warning', gray: 'badge-neutral' };
function Badge({ color, children }) {
  if (color === 'purple') return <span className="badge" style={{ background: 'var(--purple-s)', color: 'var(--purple)' }}>{children}</span>;
  return <span className={'badge ' + (BADGE[color] || 'badge-neutral')}>{children}</span>;
}

const tl = (v, d = 0) => '₺' + (parseFloat(v) || 0).toLocaleString('tr-TR', { minimumFractionDigits: d, maximumFractionDigits: d });

function timeAgo(ts) {
  if (!ts) return '—';
  const diff = Date.now() - new Date(ts);
  if (diff < 60000) return 'şimdi';
  if (diff < 3600000) return Math.floor(diff / 60000) + ' dk';
  if (diff < 86400000) return Math.floor(diff / 3600000) + ' sa';
  return new Date(ts).toLocaleDateString('tr-TR');
}

const eventColor = { registration: 'blue', deposit: 'green', revenue: 'teal', bet: 'yellow', ngr: 'purple', ggr: 'purple', lead: 'blue' };
const statusColor = { approved: 'green', pending: 'yellow', rejected: 'red' };
const statusLabel = { approved: 'Onaylı', pending: 'Bekliyor', rejected: 'Reddedildi' };
const FLAGS = { GE: '🇬🇪', TR: '🇹🇷', RU: '🇷🇺', UA: '🇺🇦', AZ: '🇦🇿', DE: '🇩🇪', US: '🇺🇸', GB: '🇬🇧' };
const deviceIcon = d => (d === 'mobile' ? '📱' : d === 'desktop' ? '🖥️' : d === 'tablet' ? '📟' : '');

function Stat({ label, value, color = 'var(--text)', icon }) {
  return (
    <div className="stat-card">
      {icon && <div className="stat-ic" style={{ background: 'var(--surface3)', color }}><Ic n={icon} s={18} /></div>}
      <div className="stat-value" style={{ color }}>{value}</div>
      <div className="stat-label">{label}</div>
    </div>
  );
}

function Section({ title, icon, children, right, pad = true }) {
  return (
    <div className="card" style={{ padding: 0, overflow: 'hidden', minWidth: 0 }}>
      <div className="sec-title"><span className="flex-center gap-8">{icon && <Ic n={icon} s={18} c="var(--link)" />}{title}</span>{right}</div>
      <div style={pad ? { padding: 14 } : undefined}>{children}</div>
    </div>
  );
}

export default function Affiliate() {
  const navigate = useNavigate();
  const [tab, setTab] = useState('dashboard');
  const [campaigns, setCampaigns] = useState([]);
  const [conversions, setConversions] = useState([]);
  const [clicks, setClicks] = useState([]);
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [editCamp, setEditCamp] = useState(null);
  const [selCamp, setSelCamp] = useState(null);
  const [copied, setCopied] = useState('');
  const [selConv, setSelConv] = useState(null);
  const [dateFrom, setDateFrom] = useState(() => { const d = new Date(); d.setDate(d.getDate() - 30); return d.toISOString().split('T')[0]; });
  const [dateTo, setDateTo] = useState(new Date().toISOString().split('T')[0]);
  const [showFilters, setShowFilters] = useState(false);

  const [fEvent, setFEvent] = useState('');
  const [fStatus, setFStatus] = useState('');
  const [fCountry, setFCountry] = useState('');
  const [fDevice, setFDevice] = useState('');
  const [fPayment, setFPayment] = useState('');
  const [fFirstDep, setFFirstDep] = useState('');
  const [fPlayer, setFPlayer] = useState('');

  const empty = { name: '', company: '', commission_type: 'cpa', cpa_amount: 0, revshare_percent: 0, currency: 'TRY', notify_bot_token: '', notify_chat_id: '', notes: '' };
  const [form, setForm] = useState(empty);

  useEffect(() => { loadCampaigns(); loadStats(); }, []);

  async function loadCampaigns() { try { const r = await api.get('/affiliate/campaigns'); setCampaigns(r.data); } catch (e) { /* noop */ } }
  async function loadStats() { try { const r = await api.get('/affiliate/stats', { params: { date_from: dateFrom, date_to: dateTo, campaign_id: selCamp?.id } }); setStats(r.data); } catch (e) { /* noop */ } }
  async function loadConversions(campId) {
    try { const r = await api.get('/affiliate/conversions', { params: { campaign_id: campId, event_type: fEvent, status: fStatus, country: fCountry, device: fDevice, payment_method: fPayment, first_deposit: fFirstDep, player_id: fPlayer, limit: 150 } }); setConversions(r.data); } catch (e) { /* noop */ }
  }
  async function loadClicks(campId) { try { const r = await api.get('/affiliate/clicks', { params: { campaign_id: campId, limit: 100 } }); setClicks(r.data); } catch (e) { /* noop */ } }

  async function submitForm(e) {
    e.preventDefault(); setLoading(true);
    try {
      if (editCamp) { const r = await api.put(`/affiliate/campaigns/${editCamp.id}`, form); setCampaigns(p => p.map(c => (c.id === editCamp.id ? r.data : c))); }
      else { await api.post('/affiliate/campaigns', form); loadCampaigns(); }
      setShowForm(false); setEditCamp(null); setForm(empty);
    } catch (ex) { alert('Hata: ' + (ex.response?.data?.error || ex.message)); }
    setLoading(false);
  }
  async function deleteCamp(c) {
    if (!window.confirm(`"${c.name}" silinsin mi?`)) return;
    try { await api.delete(`/affiliate/campaigns/${c.id}`); loadCampaigns(); if (selCamp?.id === c.id) setSelCamp(null); } catch (ex) { alert('Hata: ' + ex.message); }
  }
  async function refreshToken(c) {
    if (!window.confirm('Token yenilensin mi? Eski postback adresi çalışmaz hale gelir.')) return;
    try { const r = await api.post(`/affiliate/campaigns/${c.id}/refresh-token`); setCampaigns(p => p.map(x => (x.id === c.id ? r.data : x))); } catch (ex) { alert('Hata: ' + ex.message); }
  }
  async function updateStatus(id, status) {
    try { await api.put(`/affiliate/conversions/${id}`, { status }); setConversions(p => p.map(c => (c.id === id ? { ...c, status } : c))); } catch (ex) { alert('Hata: ' + ex.message); }
  }
  function copy(text, key) {
    try {
      if (navigator.clipboard && window.isSecureContext) navigator.clipboard.writeText(text).then(() => { setCopied(key); setTimeout(() => setCopied(''), 2000); });
      else {
        const el = document.createElement('textarea');
        el.value = text; el.style.position = 'fixed'; el.style.opacity = '0';
        document.body.appendChild(el); el.focus(); el.select(); document.execCommand('copy'); document.body.removeChild(el);
        setCopied(key); setTimeout(() => setCopied(''), 2000);
      }
    } catch (e) { alert('Kopyalanamadı, manuel kopyalayın:\n\n' + text); }
  }
  const pbUrl = c => `${BASE_URL}/api/affiliate/postback/${c.token}`;
  const fullPbUrl = c => `${pbUrl(c)}?click_id={click_id}&event={event}&amount={amount}&currency={currency}&player_id={player_id}&country={country}&device={device}&payment_method={payment_method}&first_deposit={first_deposit}&ggr={ggr}&ngr={ngr}&game_type={game_type}&sport={sport}&promo_code={promo_code}`;
  function openEdit(c) {
    setForm({ name: c.name, company: c.company, commission_type: c.commission_type, cpa_amount: c.cpa_amount, revshare_percent: c.revshare_percent, currency: c.currency, notify_bot_token: c.notify_bot_token || '', notify_chat_id: c.notify_chat_id || '', notes: c.notes || '' });
    setEditCamp(c); setShowForm(true);
  }
  function switchTab(v) {
    setTab(v);
    if (v === 'conversions') loadConversions(selCamp?.id);
    if (v === 'clicks') loadClicks(selCamp?.id);
  }
  function clearFilters() { setFEvent(''); setFStatus(''); setFDevice(''); setFCountry(''); setFPayment(''); setFPlayer(''); setFFirstDep(''); setSelCamp(null); loadConversions(); }

  const campSelect = (onChange, style) => (
    <select className="input" style={style} value={selCamp?.id || ''} onChange={e => { const c = campaigns.find(x => x.id === parseInt(e.target.value, 10)); setSelCamp(c || null); if (onChange) onChange(c); }}>
      <option value="">Tüm kampanyalar</option>
      {campaigns.map(c => <option key={c.id} value={c.id}>{c.company} — {c.name}</option>)}
    </select>
  );
  const ov = stats?.overview || {};
  const activeFilters = [fEvent, fStatus, fDevice, fCountry, fPayment, fPlayer, fFirstDep].filter(Boolean).length + (selCamp ? 1 : 0);

  /* Konversiyonlar sekmesindeyken alt başlıktaki "komisyon" kelimesi gizli giriş */
  const subtitle = (
    <>postback takip & <span onClick={tab === 'conversions' ? () => navigate('/telegram') : undefined}>komisyon</span> yönetimi</>
  );

  return (
    <div className="page-enter">
      <PageHeader
        title="Affiliate"
        subtitle={subtitle}
        actions={<button className="btn btn-primary" onClick={() => { setEditCamp(null); setForm(empty); setShowForm(true); }}><Ic n="plus" s={18} />Kampanya ekle</button>}
      />

      <div className="tabs" style={{ marginBottom: 18 }}>
        {[['dashboard', 'Genel bakış'], ['campaigns', `Kampanyalar${campaigns.length ? ` (${campaigns.length})` : ''}`], ['conversions', 'Konversiyonlar'], ['clicks', 'Tıklamalar']].map(([v, l]) => (
          <button key={v} className={'tab' + (tab === v ? ' active' : '')} onClick={() => switchTab(v)}>{l}</button>
        ))}
      </div>

      {/* ── GENEL BAKIŞ ── */}
      {tab === 'dashboard' && (
        <div>
          <div className="filter-row">
            {campSelect(null, { maxWidth: 280 })}
            <input type="date" className="input" value={dateFrom} onChange={e => setDateFrom(e.target.value)} style={{ maxWidth: 170 }} />
            <input type="date" className="input" value={dateTo} onChange={e => setDateTo(e.target.value)} style={{ maxWidth: 170 }} />
            <button className="btn btn-teal" onClick={loadStats}><Ic n="refresh" s={16} />Güncelle</button>
          </div>

          {stats && (
            <>
              <div className="stats-grid">
                <Stat label="Konversiyon" value={fmtNum(ov.total_conversions)} color="var(--link)" icon="chart" />
                <Stat label="Benzersiz oyuncu" value={fmtNum(ov.unique_players)} color="var(--info)" icon="users" />
                <Stat label="Kayıt" value={fmtNum(ov.registrations)} color="var(--info)" icon="userPlus" />
                <Stat label="Depozit" value={fmtNum(ov.deposits)} color="var(--success)" icon="money" />
                <Stat label="İlk depozit" value={fmtNum(ov.first_deposits)} color="var(--warning)" icon="star" />
                <Stat label="Toplam tutar" value={tl(ov.total_amount)} />
                <Stat label="Toplam GGR" value={tl(ov.total_ggr)} color="var(--purple)" />
                <Stat label="Toplam NGR" value={tl(ov.total_ngr)} color="var(--purple)" />
                <Stat label="Ort. depozit" value={tl(ov.avg_deposit, 2)} color="var(--text2)" />
                <Stat label="Onaylı kazanç" value={tl(ov.approved_earning, 2)} color="var(--success)" />
                <Stat label="Bekleyen" value={tl(ov.pending_earning, 2)} color="var(--warning)" />
              </div>

              <div className="grid-2" style={{ marginBottom: 14 }}>
                {stats.byCompany?.length > 0 && (
                  <Section title="Firma performansı" icon="building" pad={false}>
                    <div className="table-wrap rtable-wrap">
                      <table className="rtable">
                        <thead><tr>{['Firma', 'Konv.', 'Oyuncu', 'Kayıt', 'Depozit', '1. Dep', 'GGR', 'NGR', 'Kazanç'].map(h => <th key={h}>{h}</th>)}</tr></thead>
                        <tbody>
                          {stats.byCompany.map((c, i) => (
                            <tr key={i}>
                              <td data-label="Firma" className="full" style={{ fontWeight: 600 }}>{c.company}</td>
                              <td data-label="Konv.">{c.conversions}</td>
                              <td data-label="Oyuncu" style={{ color: 'var(--info)' }}>{c.unique_players}</td>
                              <td data-label="Kayıt" style={{ color: 'var(--info)' }}>{c.regs}</td>
                              <td data-label="Depozit" style={{ color: 'var(--success)' }}>{c.deposits}</td>
                              <td data-label="1. Dep" style={{ color: 'var(--warning)' }}>{c.first_deposits}</td>
                              <td data-label="GGR" style={{ color: 'var(--purple)' }}>{tl(c.total_ggr)}</td>
                              <td data-label="NGR" style={{ color: 'var(--purple)' }}>{tl(c.total_ngr)}</td>
                              <td data-label="Kazanç" style={{ color: 'var(--success)', fontWeight: 700 }}>{tl(c.earned, 2)}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </Section>
                )}
                {stats.byCountry?.length > 0 && (
                  <Section title="Ülkeler" icon="globe">
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 10, maxHeight: 300, overflowY: 'auto' }}>
                      {stats.byCountry.map((c, i) => (
                        <div key={i}>
                          <div className="flex-between" style={{ gap: 8, marginBottom: 4 }}>
                            <span className="flex-center gap-8" style={{ fontWeight: 600 }}><span style={{ fontSize: 18 }}>{FLAGS[c.country] || '🌍'}</span>{c.country}</span>
                            <span style={{ fontSize: 12.5, color: 'var(--text3)', display: 'flex', gap: 10, flexWrap: 'wrap', justifyContent: 'flex-end' }}>
                              <span>{c.count} konv.</span><span style={{ color: 'var(--success)' }}>{c.deposits} dep.</span><span style={{ color: 'var(--link)', fontWeight: 700 }}>{tl(c.earned)}</span>
                            </span>
                          </div>
                          <div className="progress-bar"><div className="progress-fill" style={{ width: `${Math.min(100, (c.count / (stats.byCountry[0].count || 1)) * 100)}%` }} /></div>
                        </div>
                      ))}
                    </div>
                  </Section>
                )}
              </div>

              <div className="grid-3" style={{ marginBottom: 14 }}>
                {stats.byDevice?.length > 0 && (
                  <Section title="Cihaz" icon="device">
                    {stats.byDevice.map((d, i) => (
                      <div key={i} className="flex-between" style={{ padding: '5px 0' }}>
                        <span>{deviceIcon(d.device)} {d.device}</span>
                        <span style={{ fontSize: 12.5, color: 'var(--text3)', display: 'flex', gap: 10 }}><span>{d.count}</span><span style={{ color: 'var(--success)' }}>{d.deposits} dep.</span></span>
                      </div>
                    ))}
                  </Section>
                )}
                {stats.byPayment?.length > 0 && (
                  <Section title="Ödeme yöntemi" icon="card">
                    {stats.byPayment.map((p, i) => (
                      <div key={i} className="flex-between" style={{ padding: '5px 0', gap: 8 }}>
                        <span className="truncate">{p.payment_method}</span>
                        <span style={{ fontSize: 12.5, color: 'var(--text3)', display: 'flex', gap: 10, flexShrink: 0 }}><span>{p.count}</span><span style={{ color: 'var(--success)' }}>{tl(p.total_amount)}</span></span>
                      </div>
                    ))}
                  </Section>
                )}
                {(stats.byGameType?.length > 0 || stats.bySport?.length > 0) && (
                  <Section title="Oyun / spor" icon="game">
                    {(stats.byGameType || []).map((g, i) => (
                      <div key={'g' + i} className="flex-between" style={{ padding: '5px 0', fontSize: 13.5 }}><span>{g.game_type}</span><span className="text-muted">{g.count} · GGR {tl(g.total_ggr)}</span></div>
                    ))}
                    {(stats.bySport || []).map((s, i) => (
                      <div key={'s' + i} className="flex-between" style={{ padding: '5px 0', fontSize: 13.5 }}><span>⚽ {s.sport}</span><span className="text-muted">{s.count}</span></div>
                    ))}
                  </Section>
                )}
              </div>

              {stats.topPlayers?.length > 0 && (
                <div style={{ marginBottom: 14 }}>
                  <Section title="En çok yatıran oyuncular" icon="crown" pad={false}>
                    <div className="table-wrap rtable-wrap">
                      <table className="rtable">
                        <thead><tr>{['#', 'Oyuncu ID', 'Event', 'Depozit', 'Toplam tutar', 'Komisyon', 'Son aktivite'].map(h => <th key={h}>{h}</th>)}</tr></thead>
                        <tbody>
                          {stats.topPlayers.map((p, i) => (
                            <tr key={i}>
                              <td data-label="#" className="text-muted">{i + 1}</td>
                              <td data-label="Oyuncu ID" className="mono" style={{ fontSize: 12.5 }}>{p.player_id}</td>
                              <td data-label="Event">{p.total_events}</td>
                              <td data-label="Depozit" style={{ color: 'var(--success)' }}>{p.deposits}</td>
                              <td data-label="Toplam tutar" style={{ color: 'var(--success)', fontWeight: 700 }}>{tl(p.total_amount, 2)}</td>
                              <td data-label="Komisyon" style={{ color: 'var(--link)' }}>{tl(p.commission, 2)}</td>
                              <td data-label="Son aktivite" className="text-muted">{timeAgo(p.last_activity)}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </Section>
                </div>
              )}

              {stats.daily?.length > 0 && (
                <Section title="Günlük performans" icon="calendar" pad={false}>
                  <div className="table-wrap rtable-wrap">
                    <table className="rtable">
                      <thead><tr>{['Tarih', 'Konv.', 'Depozit', 'Kayıt', 'Toplam tutar', 'Kazanç'].map(h => <th key={h}>{h}</th>)}</tr></thead>
                      <tbody>
                        {[...stats.daily].reverse().map((d, i) => (
                          <tr key={i}>
                            <td data-label="Tarih" className="full" style={{ fontWeight: 600 }}>{new Date(d.date).toLocaleDateString('tr-TR')}</td>
                            <td data-label="Konv.">{d.conversions}</td>
                            <td data-label="Depozit" style={{ color: 'var(--success)' }}>{d.deposits}</td>
                            <td data-label="Kayıt" style={{ color: 'var(--info)' }}>{d.regs}</td>
                            <td data-label="Toplam tutar">{tl(d.total_amount)}</td>
                            <td data-label="Kazanç" style={{ color: 'var(--success)', fontWeight: 700 }}>{tl(d.earned, 2)}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </Section>
              )}
            </>
          )}
        </div>
      )}

      {/* ── KAMPANYALAR ── */}
      {tab === 'campaigns' && (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          {!campaigns.length && <div className="card empty-state"><div className="icon"><Ic n="target" s={44} /></div><p>Henüz kampanya yok</p></div>}
          {campaigns.map(c => (
            <div key={c.id} className="card">
              <div className="flex-between" style={{ alignItems: 'flex-start', gap: 12, flexWrap: 'wrap', marginBottom: 14 }}>
                <div style={{ minWidth: 0 }}>
                  <div className="flex-center gap-8" style={{ flexWrap: 'wrap', marginBottom: 4 }}>
                    <span style={{ fontSize: 16.5, fontWeight: 700 }}>{c.name}</span>
                    <Badge color={c.is_active ? 'green' : 'gray'}>{c.is_active ? 'Aktif' : 'Pasif'}</Badge>
                    <Badge color="blue">{(c.commission_type || '').toUpperCase()}</Badge>
                  </div>
                  <div className="text-muted" style={{ fontSize: 13.5 }}>
                    {c.company} · {c.commission_type === 'cpa' ? `CPA ${tl(c.cpa_amount, 2)}` : c.commission_type === 'revshare' ? `RevShare %${c.revshare_percent}` : `CPA ${tl(c.cpa_amount, 2)} + %${c.revshare_percent}`} · {c.currency}
                  </div>
                </div>
                <div className="flex gap-6" style={{ flexWrap: 'wrap' }}>
                  <button className="btn btn-sm btn-teal" onClick={() => { setSelCamp(c); setTab('conversions'); loadConversions(c.id); }}><Ic n="chart" s={15} />Detay</button>
                  <button className="btn btn-sm btn-ghost" onClick={() => openEdit(c)}><Ic n="edit" s={15} />Düzenle</button>
                  <button className="btn btn-sm btn-ghost" onClick={() => refreshToken(c)}><Ic n="refresh" s={15} />Token</button>
                  <button className="btn btn-sm btn-danger" onClick={() => deleteCamp(c)} title="Sil"><Ic n="trash" s={15} /></button>
                </div>
              </div>

              <div className="keep-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(104px, 1fr))', gap: 8, marginBottom: 14 }}>
                {[['Tıklama', fmtNum(c.total_clicks), 'var(--text)'], ['Konv.', fmtNum(c.total_conversions), 'var(--link)'], ['Kayıt', fmtNum(c.total_regs), 'var(--info)'], ['Depozit', fmtNum(c.total_deposits), 'var(--success)'], ['1. Dep', fmtNum(c.first_deposits), 'var(--warning)'], ['GGR', tl(c.total_ggr), 'var(--purple)'], ['NGR', tl(c.total_ngr), 'var(--purple)'], ['Onaylı', tl(c.total_earned, 2), 'var(--success)'], ['Bekleyen', tl(c.pending_earned, 2), 'var(--warning)']].map(([l, v, col]) => (
                  <div key={l} className="kv"><div className="k">{l}</div><div className="v" style={{ color: col, fontSize: 15.5 }}>{v}</div></div>
                ))}
              </div>

              <div style={{ background: 'var(--bg2)', borderRadius: 10, padding: 12 }}>
                <div className="flex-between" style={{ marginBottom: 8 }}>
                  <span style={{ fontSize: 12.5, fontWeight: 600, color: 'var(--link)' }}>Postback URL</span>
                  <button className="btn btn-xs btn-teal" onClick={() => copy(fullPbUrl(c), c.id)}><Ic n={copied === c.id ? 'check' : 'copy'} s={13} />{copied === c.id ? 'Kopyalandı' : 'Kopyala'}</button>
                </div>
                <code style={{ display: 'block', fontSize: 11.5, padding: '8px 10px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{fullPbUrl(c)}</code>
                <div style={{ fontSize: 12, color: 'var(--text3)', lineHeight: 1.7, marginTop: 8 }}>
                  <b style={{ color: 'var(--text2)' }}>Zorunlu:</b> click_id, event (registration/deposit/revenue/bet/ngr/ggr), amount, currency<br />
                  <b style={{ color: 'var(--text2)' }}>Ekstra:</b> player_id, country, device, os, language, first_deposit, deposit_count, total_deposits, balance, bonus_used, payment_method, bet_count, ggr, ngr, sport, game_type, promo_code, utm_source, utm_medium, utm_campaign
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* ── KONVERSİYONLAR ── */}
      {tab === 'conversions' && (
        <div>
          <div className="card" style={{ padding: 14, marginBottom: 14 }}>
            <div className="flex-between" style={{ gap: 8, flexWrap: 'wrap' }}>
              <div className="flex-center gap-8" style={{ flexWrap: 'wrap', minWidth: 0, flex: 1 }}>
                {campSelect(null, { maxWidth: 280, flex: '1 1 200px' })}
                <button className={'btn ' + (showFilters ? 'btn-teal' : 'btn-ghost')} onClick={() => setShowFilters(v => !v)}><Ic n="filter" s={16} />Filtreler{activeFilters ? ` (${activeFilters})` : ''}</button>
              </div>
              <div className="flex gap-6">
                <button className="btn btn-primary" onClick={() => loadConversions(selCamp?.id)}><Ic n="search" s={16} />Ara</button>
                {activeFilters > 0 && <button className="btn btn-ghost" onClick={clearFilters}><Ic n="close" s={16} />Temizle</button>}
              </div>
            </div>
            {showFilters && (
              <div className="keep-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(min(100%, 170px), 1fr))', gap: 8, marginTop: 12 }}>
                <select className="input" value={fEvent} onChange={e => setFEvent(e.target.value)}><option value="">Tüm eventler</option>{['registration', 'deposit', 'revenue', 'bet', 'ngr', 'ggr', 'lead'].map(v => <option key={v}>{v}</option>)}</select>
                <select className="input" value={fStatus} onChange={e => setFStatus(e.target.value)}><option value="">Tüm durumlar</option>{['pending', 'approved', 'rejected'].map(v => <option key={v} value={v}>{statusLabel[v]}</option>)}</select>
                <select className="input" value={fDevice} onChange={e => setFDevice(e.target.value)}><option value="">Tüm cihazlar</option>{['mobile', 'desktop', 'tablet'].map(v => <option key={v}>{v}</option>)}</select>
                <select className="input" value={fFirstDep} onChange={e => setFFirstDep(e.target.value)}><option value="">Tüm depozitler</option><option value="true">Sadece ilk depozit</option></select>
                <input className="input" value={fCountry} onChange={e => setFCountry(e.target.value)} placeholder="Ülke (GE, TR…)" />
                <input className="input" value={fPayment} onChange={e => setFPayment(e.target.value)} placeholder="Ödeme yöntemi" />
                <input className="input" value={fPlayer} onChange={e => setFPlayer(e.target.value)} placeholder="Oyuncu ID" />
              </div>
            )}
          </div>

          {!conversions.length ? (
            <div className="card empty-state"><div className="icon"><Ic n="money" s={44} /></div><p>Konversiyon yok</p></div>
          ) : (
            <div className="card table-wrap rtable-wrap" style={{ padding: 0 }}>
              <table className="rtable">
                <thead><tr>{['Firma', 'Event', 'Oyuncu ID', 'Ülke', 'Cihaz', 'Tutar', 'GGR', 'NGR', 'Komisyon', '1. Dep', 'Ödeme', 'Oyun', 'Promo', 'Durum', 'Tarih', ''].map((h, i) => <th key={i}>{h}</th>)}</tr></thead>
                <tbody>
                  {conversions.map(cv => (
                    <tr key={cv.id} style={{ cursor: 'pointer' }} onClick={() => setSelConv(cv)}>
                      <td data-label="Firma" style={{ fontWeight: 600, whiteSpace: 'nowrap' }}>{cv.company}</td>
                      <td data-label="Event"><Badge color={eventColor[cv.event_type] || 'gray'}>{cv.event_type}</Badge></td>
                      <td data-label="Oyuncu ID" className="mono" style={{ fontSize: 12, color: 'var(--text2)' }}>{cv.player_id || '—'}</td>
                      <td data-label="Ülke">{cv.country ? `${FLAGS[cv.country] || ''} ${cv.country}` : '—'}</td>
                      <td data-label="Cihaz" className="text-muted">{cv.device ? `${deviceIcon(cv.device)} ${cv.device}` : '—'}</td>
                      <td data-label="Tutar" style={{ color: cv.amount > 0 ? 'var(--success)' : 'var(--text3)' }}>{cv.amount > 0 ? tl(cv.amount, 2) : '—'}</td>
                      <td data-label="GGR" style={{ color: cv.ggr > 0 ? 'var(--purple)' : 'var(--text3)' }}>{cv.ggr > 0 ? tl(cv.ggr) : '—'}</td>
                      <td data-label="NGR" style={{ color: cv.ngr > 0 ? 'var(--purple)' : 'var(--text3)' }}>{cv.ngr > 0 ? tl(cv.ngr) : '—'}</td>
                      <td data-label="Komisyon" style={{ color: cv.commission > 0 ? 'var(--success)' : 'var(--text3)', fontWeight: cv.commission > 0 ? 700 : 400 }}>{cv.commission > 0 ? tl(cv.commission, 2) : '—'}</td>
                      <td data-label="1. Dep">{cv.first_deposit ? <Badge color="yellow">Evet</Badge> : '—'}</td>
                      <td data-label="Ödeme" className="text-muted">{cv.payment_method || '—'}</td>
                      <td data-label="Oyun" className="text-muted">{cv.game_type || cv.sport || '—'}</td>
                      <td data-label="Promo" className="text-muted">{cv.promo_code || '—'}</td>
                      <td data-label="Durum"><Badge color={statusColor[cv.status] || 'gray'}>{statusLabel[cv.status] || cv.status}</Badge></td>
                      <td data-label="Tarih" className="text-muted" style={{ whiteSpace: 'nowrap' }}>{timeAgo(cv.created_at)}</td>
                      <td className="full nolabel" onClick={e => e.stopPropagation()}>
                        {cv.status === 'pending' && (
                          <div className="flex gap-6">
                            <button className="btn btn-xs btn-success" onClick={() => updateStatus(cv.id, 'approved')}><Ic n="check" s={13} />Onayla</button>
                            <button className="btn btn-xs btn-danger" onClick={() => updateStatus(cv.id, 'rejected')}><Ic n="close" s={13} />Reddet</button>
                          </div>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}

      {/* ── TIKLAMALAR ── */}
      {tab === 'clicks' && (
        <div>
          <div className="filter-row">
            {campSelect(c => loadClicks(c?.id), { maxWidth: 280 })}
            <button className="btn btn-ghost" onClick={() => loadClicks(selCamp?.id)}><Ic n="refresh" s={16} />Yenile</button>
          </div>
          {!clicks.length ? (
            <div className="card empty-state"><div className="icon"><Ic n="click" s={44} /></div><p>Tıklama yok</p></div>
          ) : (
            <div className="card table-wrap rtable-wrap" style={{ padding: 0 }}>
              <table className="rtable">
                <thead><tr>{['Click ID', 'Kampanya', 'Kaynak (sub1)', 'Kullanıcı (sub2)', 'Ülke', 'Cihaz', 'OS', 'UTM source', 'UTM campaign', 'Konv.', 'Tarih'].map(h => <th key={h}>{h}</th>)}</tr></thead>
                <tbody>
                  {clicks.map(cl => (
                    <tr key={cl.id}>
                      <td data-label="Click ID" className="mono" style={{ fontSize: 12, color: 'var(--text3)' }}>{(cl.click_id || '').slice(0, 12)}…</td>
                      <td data-label="Kampanya" style={{ fontWeight: 600 }}>{cl.campaign_name}</td>
                      <td data-label="Kaynak (sub1)" className="text-muted">{cl.sub1 || '—'}</td>
                      <td data-label="Kullanıcı (sub2)" className="text-muted">{cl.sub2 || '—'}</td>
                      <td data-label="Ülke">{cl.country ? `${FLAGS[cl.country] || ''} ${cl.country}` : '—'}</td>
                      <td data-label="Cihaz">{cl.device ? `${deviceIcon(cl.device)} ${cl.device}` : '—'}</td>
                      <td data-label="OS" className="text-muted">{cl.os || '—'}</td>
                      <td data-label="UTM source" className="text-muted">{cl.utm_source || '—'}</td>
                      <td data-label="UTM campaign" className="text-muted">{cl.utm_campaign || '—'}</td>
                      <td data-label="Konv.">{cl.converted ? <Badge color="green">Evet</Badge> : <Badge color="gray">Yok</Badge>}</td>
                      <td data-label="Tarih" className="text-muted" style={{ whiteSpace: 'nowrap' }}>{timeAgo(cl.clicked_at)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}

      {/* ── KONVERSİYON DETAY ── */}
      {selConv && (
        <div className="modal-overlay" onClick={e => e.target === e.currentTarget && setSelConv(null)}>
          <div className="modal" style={{ maxWidth: 600, width: '100%' }}>
            <div className="flex-between" style={{ gap: 10, marginBottom: 14, flexWrap: 'wrap' }}>
              <h3 style={{ margin: 0 }}>Konversiyon #{selConv.id}</h3>
              <div className="flex gap-6">
                <Badge color={eventColor[selConv.event_type] || 'gray'}>{selConv.event_type}</Badge>
                <Badge color={statusColor[selConv.status] || 'gray'}>{statusLabel[selConv.status] || selConv.status}</Badge>
              </div>
            </div>
            <div className="kv-grid">
              {[
                ['Firma', selConv.company], ['Kampanya', selConv.campaign_name], ['Oyuncu ID', selConv.player_id || '—'], ['Click ID', selConv.click_id || '—'],
                ['Tutar', selConv.amount > 0 ? `${selConv.amount} ${selConv.currency || ''}` : '—'], ['Komisyon', selConv.commission > 0 ? tl(selConv.commission, 2) : '—'],
                ['GGR', selConv.ggr > 0 ? tl(selConv.ggr) : '—'], ['NGR', selConv.ngr > 0 ? tl(selConv.ngr) : '—'],
                ['Ülke', selConv.country ? `${FLAGS[selConv.country] || ''} ${selConv.country}` : '—'], ['Cihaz', selConv.device || '—'], ['OS', selConv.os || '—'], ['Dil', selConv.language || '—'],
                ['İlk depozit', selConv.first_deposit ? 'Evet' : '—'], ['Depozit sayısı', selConv.deposit_count || '—'], ['Toplam depozit', selConv.total_deposits > 0 ? tl(selConv.total_deposits) : '—'],
                ['Ödeme yöntemi', selConv.payment_method || '—'], ['Oyun tipi', selConv.game_type || '—'], ['Spor', selConv.sport || '—'], ['Promo kodu', selConv.promo_code || '—'],
                ['UTM source', selConv.utm_source || '—'], ['UTM medium', selConv.utm_medium || '—'], ['UTM campaign', selConv.utm_campaign || '—'],
                ['Tarih', new Date(selConv.created_at).toLocaleString('tr-TR')], ['IP', selConv.ip || '—'],
              ].map(([l, v]) => <div key={l} className="kv"><div className="k">{l}</div><div className="v">{v}</div></div>)}
            </div>
            {selConv.raw_params && (
              <div style={{ marginTop: 12 }}>
                <div style={{ fontSize: 12.5, color: 'var(--link)', marginBottom: 6, fontWeight: 600 }}>Ham veri</div>
                <pre style={{ maxHeight: 140, margin: 0, color: 'var(--text2)' }}>{JSON.stringify(selConv.raw_params, null, 2)}</pre>
              </div>
            )}
            <div className="flex gap-8" style={{ justifyContent: 'flex-end', marginTop: 16, flexWrap: 'wrap' }}>
              {selConv.status === 'pending' && (
                <>
                  <button className="btn btn-success" onClick={() => { updateStatus(selConv.id, 'approved'); setSelConv(p => ({ ...p, status: 'approved' })); }}><Ic n="check" s={16} />Onayla</button>
                  <button className="btn btn-danger" onClick={() => { updateStatus(selConv.id, 'rejected'); setSelConv(p => ({ ...p, status: 'rejected' })); }}><Ic n="close" s={16} />Reddet</button>
                </>
              )}
              <button className="btn btn-ghost" onClick={() => setSelConv(null)}>Kapat</button>
            </div>
          </div>
        </div>
      )}

      {/* ── KAMPANYA FORMU ── */}
      {showForm && (
        <div className="modal-overlay" onClick={e => e.target === e.currentTarget && setShowForm(false)}>
          <div className="modal" style={{ maxWidth: 560, width: '100%' }}>
            <h3>{editCamp ? 'Kampanyayı düzenle' : 'Yeni kampanya'}</h3>
            <form onSubmit={submitForm}>
              <div className="form-2">
                <div className="input-group"><label>Kampanya adı</label><input className="input" value={form.name} onChange={e => setForm(p => ({ ...p, name: e.target.value }))} placeholder="Kampanya adı" required /></div>
                <div className="input-group"><label>Firma</label><input className="input" value={form.company} onChange={e => setForm(p => ({ ...p, company: e.target.value }))} placeholder="Firma adı" required /></div>
              </div>
              <div className="input-group">
                <label>Komisyon modeli</label>
                <select className="input" value={form.commission_type} onChange={e => setForm(p => ({ ...p, commission_type: e.target.value }))}>
                  <option value="cpa">CPA — Sabit tutar (kayıt/depozit başına)</option>
                  <option value="revshare">RevShare — GGR/NGR yüzdesi</option>
                  <option value="hybrid">Hybrid — CPA + RevShare</option>
                </select>
              </div>
              <div className="form-3">
                {(form.commission_type === 'cpa' || form.commission_type === 'hybrid') && (
                  <div className="input-group"><label>CPA (₺)</label><input className="input" type="number" step="0.01" min="0" value={form.cpa_amount} onChange={e => setForm(p => ({ ...p, cpa_amount: e.target.value }))} /></div>
                )}
                {(form.commission_type === 'revshare' || form.commission_type === 'hybrid') && (
                  <div className="input-group"><label>RevShare (%)</label><input className="input" type="number" step="0.1" min="0" max="100" value={form.revshare_percent} onChange={e => setForm(p => ({ ...p, revshare_percent: e.target.value }))} /></div>
                )}
                <div className="input-group"><label>Para birimi</label>
                  <select className="input" value={form.currency} onChange={e => setForm(p => ({ ...p, currency: e.target.value }))}>{['TRY', 'USD', 'EUR', 'GEL', 'USDT'].map(c => <option key={c}>{c}</option>)}</select>
                </div>
              </div>
              <div style={{ borderTop: '1px solid var(--border3)', paddingTop: 14, marginTop: 2 }}>
                <div style={{ fontSize: 13.5, fontWeight: 600, marginBottom: 10 }}>Telegram bildirimleri</div>
                <div className="form-2">
                  <div className="input-group"><label>Bot token</label><input className="input" value={form.notify_bot_token} onChange={e => setForm(p => ({ ...p, notify_bot_token: e.target.value }))} placeholder="123456:AAH…" /></div>
                  <div className="input-group"><label>Chat ID</label><input className="input" value={form.notify_chat_id} onChange={e => setForm(p => ({ ...p, notify_chat_id: e.target.value }))} placeholder="@kanal veya -100xxx" /></div>
                </div>
              </div>
              <div className="input-group"><label>Notlar</label><textarea className="input" value={form.notes} onChange={e => setForm(p => ({ ...p, notes: e.target.value }))} style={{ minHeight: 60 }} placeholder="Anlaşma detayları…" /></div>
              <div className="flex gap-8" style={{ justifyContent: 'flex-end' }}>
                <button type="button" className="btn btn-ghost" onClick={() => { setShowForm(false); setEditCamp(null); }}>İptal</button>
                <button type="submit" className="btn btn-primary" disabled={loading}>{loading ? 'Kaydediliyor…' : editCamp ? 'Kaydet' : 'Oluştur'}</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
